export const isShopAddon = (id: string | undefined): boolean => {
    return !!id?.toUpperCase().includes('SHP_');
};
